export class CompanyData {
    companyName: string = '';
    notes: string = '';
    statusID: number = 0;
    typeID: number = 0;
    producerCodes = [];
    permissions = [];
    diceInfo: any = new DiceInfo;
}

export class DiceInfo {
    diceuwName: string = '';
    diceuwEmail: string = '';
    gl: number;
    au: number;
    im: number;
    umb: number;
    wc: number;
}